const isHeadless = window.location.pathname.startsWith('/headless/internal');

if (isHeadless) {
  import('./indexHeadless').then(({ default: runHeadlessApp }) => {
    runHeadlessApp();
  });
} else {
  import('./indexNormal').then(({ default: runNormalApp }) => {
    runNormalApp();
  });
}
